import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=7b3864c3&scoped=true&"
import script from "./compliance.vue?vue&type=script&lang=js&"
export * from "./compliance.vue?vue&type=script&lang=js&"
import style0 from "./compliance.vue?vue&type=style&index=0&id=7b3864c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3864c3",
  null
  
)

export default component.exports